import { Box, Typography, useTheme } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 */
/**
 * Loading component with a pulsing radar-ping dot.
 *
 * @param {Object} props
 * @param {MUIColor} props.color - Dot and text color.
 * @param {String} props.waitingMessage - Message to show while waiting.
 * @param {Number} [props.size=14] - Dot diameter in px.
 * @param {String} [props.padding="20px"] - Padding around the component.
 * @returns {JSX.Element} The DataLoadingPulse component
 */
const DataLoadingPulse = ( { color = 'primary', waitingMessage, size = 14, padding = "20px" } ) => {

    const { palette } = useTheme()
    const dotColor = palette[color]?.main || color

    return (
        <Box padding={padding} display="flex" gap="10px" alignItems="center">
            <Box position="relative" flexShrink={0} width={`${size}px`} height={`${size}px`} display="flex" alignItems="center" justifyContent="center">
                <Box
                    position="absolute"
                    width="100%"
                    height="100%"
                    borderRadius="50%"
                    bgcolor={dotColor}
                    sx={{
                        '@keyframes pulse-ring': {
                            '0%': { transform: 'scale(0.7)', opacity: 0.8 },
                            '100%': { transform: 'scale(2.4)', opacity: 0 },
                        },
                        animation: 'pulse-ring 1.4s ease-out infinite',
                    }}
                />
                <Box width="50%" height="50%" borderRadius="50%" bgcolor={dotColor} />
            </Box>
            {waitingMessage && <Typography fontSize="14px" fontWeight="500" color={color} variant='caption'>{waitingMessage}</Typography>}
        </Box>
    )
}

DataLoadingPulse.propTypes = {
    color: PropTypes.string,
    waitingMessage: PropTypes.string,
    size: PropTypes.number,
    padding: PropTypes.string,
}

export default DataLoadingPulse
